import React from 'react';

function PageInfo(props) {
  return (
    <>
      <div className="titles">
        <h3 className='title'>Portfolio</h3>
        <p className='commit'>Check my portfolios</p>
      </div>
    </>
  );
}

export default PageInfo;